mutation UpdateUser($id: ID!, $roleId: ID!) {
    updateUser(id: $id, roleId: $roleId) {
        id
    }
}
